import SECTION_TYPES from './types';
import { type ISection } from 'src/models';
import { type State } from './reducer';

function getAll(courseId: number) {
	return {
		type: SECTION_TYPES.GET_ALL,
		payload: { courseId },
	};
}

function getByUser(courseId: number) {
	return {
		type: SECTION_TYPES.GET_BY_USER,
		payload: { courseId },
	};
}

function setAll(sections: ISection[]) {
	return {
		type: SECTION_TYPES.SET_ALL,
		payload: { sections },
	};
}

function getOne(id: number) {
	return {
		type: SECTION_TYPES.GET_ONE,
		payload: { id },
	};
}

function setOne(section: ISection) {
	return {
		type: SECTION_TYPES.SET_ONE,
		payload: { section },
	};
}

function create(section: ISection) {
	return {
		type: SECTION_TYPES.CREATE,
		payload: { section },
	};
}

function update(section: ISection) {
	return {
		type: SECTION_TYPES.UPDATE,
		payload: { section },
	};
}

function remove(id: number) {
	return {
		type: SECTION_TYPES.REMOVE,
		payload: { id },
	};
}

function updateShowRandom(id: number, value: boolean) {
	return {
		type: SECTION_TYPES.UPDATE_SHOW_RANDOM,
		payload: { id, value },
	};
}

function updateQuestionsExam(id: number, value: string) {
	return {
		type: SECTION_TYPES.UPDATE_QUESTIONS_EXAM,
		payload: { id, value },
	};
}

function initialState() {
	return {
		type: SECTION_TYPES.INITIAL_STATE,
	};
}

function updateOrder(courseId: number, sections: ISection[]) {
	return {
		type: SECTION_TYPES.UPDATE_ORDER,
		payload: { courseId, sections },
	};
}

function track(sectionId: number, userId: string, type: string) {
	return {
		type: SECTION_TYPES.TRACK,
		payload: { sectionId, userId, type },
	};
}

export type Type = keyof State;

function set(key: Type, value: any) {
	return {
		type: SECTION_TYPES.SET,
		payload: { key, value },
	};
}

const sectionActions = {
	getAll,
	getByUser,
	setAll,
	getOne,
	setOne,
	create,
	update,
	remove,
	updateShowRandom,
	updateQuestionsExam,
	initialState,
	updateOrder,
	track,
	set,
};

export default sectionActions;
